import * as React from 'react';
import loc from 'owa-localize';
import { addAsATask } from './ListOrDropHint.locstring.json';
import getDropState from '../selectors/getDropState';
import { observer } from 'mobx-react-lite';

// VSO #58249 Remove Tasks View DnD code after shipping combined DnD exp

const styles = require('./TodoPanelDropHint.scss');
const classNames = require('classnames/bind').bind(styles);

const TodoPanelDropHint = observer(function TodoPanelDropHint() {
    const dropHintAreaClassNames = classNames(styles.dropHintAreaInner, {
        isDraggingItemsIntoPanel: getDropState().isDragOver,
    });

    return (
        <div className={styles.dropHintArea}>
            <span className={dropHintAreaClassNames}>
                <span className={styles.dropHintIcon} />
                <span className={styles.dropHintLabel}>{loc(addAsATask)}</span>
            </span>
        </div>
    );
});
export default TodoPanelDropHint;
